import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Surveys_ModuleContextService } from './Surveys.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Surveys_date_filter_dd_ComponentContextService {
  private readonly moduleContext: Surveys_ModuleContextService;

  constructor(moduleContext: Surveys_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'date_filter_dd',
      type: ComponentType.selector
    }
  }
}